import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class CompanyCloudcanteens extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/cloud-canteens'
    }

    listUserBudgets(userId, query) {
        return ResponseHandler.handle(
            apiClient.get(`${this.getBaseUrl()}/budgets-for-user/${userId}`, {
                params: query,
            })
        )
    }

    updateUserBudget(canteenId, credits, userId) {
        return ResponseHandler.handle(
            apiClient.post(`${this.getBaseUrl()}/budgets-for-user/${userId}`, {
                canteenId,
                credits,
            })
        )
    }
}

// core-api answers a group order POST into a slot that already has one with 409 slot_taken (tasks#222
// Part 2, spec R2); the old create form is the deliberate path to a second order in a slot, so it asks
// for it with ?allowSlotDuplicate=1. The calendar modal uses the plain client and handles the 409.
class CompanyCloudcanteensDuplicateSlot extends CompanyCloudcanteens {
    create(entity) {
        return ResponseHandler.handle(
            apiClient.post(this.getBaseUrl(), entity, {
                params: { allowSlotDuplicate: 1 },
            })
        ).then(this.refreshSelectapiStore.bind(this))
    }
}

export const companyCloudcanteensDuplicateSlot = new CompanyCloudcanteensDuplicateSlot()

export default new CompanyCloudcanteens()
